import { Categoria } from "../Categoria/Categoria"
import { Tematica } from "../Tematica/Tematica"

export interface AnunciosData {
    idAnuncio: number,
    idArea: number,
    dtEnvio: string,
    txTitulo: string,
    txTexto: string,
    txImagen: string,
    Imagen: File | null,
    txtImagenCaratula: string,
    ImagenCaratula: File | null,
    ordenPresentacion: number,
    estadoMiEspol: string,
    dtPublicacion: string,
    dtVigencia: string,
    bdPublicarAutomatico: boolean,
    bdIsReiterativo: boolean,
    txUrl: string,
    txLugar: string,
    txtUrlMaps: string,
    dtInicio: string,
    dtFin: string,
    bdTipo: string,
    bdEstado: string,
    bdEstadoRegistro: boolean,
    bdAmbito: string,
    dtUltimoCambio: string,
    rowVersion: string,
    softDeleted: boolean,
    visited: boolean,
    interacciones: number,
    audiencias: Array<number>,
    facultadesGrado: Array<number>,
    programasGrado: Array<string>,
    facultadesPostGrado: Array<number>,
    programasPostGrado: Array<string>,
    idTipoEvento: number,
    nombreTipoEvento?: string,
    tematicas: Array<Tematica>,
    categorias: Array<Categoria>,
    esEnEspol: boolean,
    idCampus: number,
    idZona: number,
    idBloque: number,
    idTipoUbicacion: number,
    idUbicacion: number
}

export function GetVoidAnunciosData(): AnunciosData {
    return {
        idAnuncio: 0,
        idTipoEvento: 0,
        idArea: 0,
        dtEnvio: '',
        txTitulo: '',
        txTexto: '',
        txImagen: '',
        Imagen: null,
        txtImagenCaratula: '',
        ImagenCaratula: null,
        ordenPresentacion: 0,
        estadoMiEspol: '',
        dtPublicacion: '',
        dtVigencia: '',
        bdPublicarAutomatico: false,
        bdIsReiterativo: false,
        txUrl: '',
        txLugar: '',
        txtUrlMaps: '',
        dtInicio: '',
        dtFin: '',
        bdTipo: '',
        bdEstado: '',
        bdEstadoRegistro: false,
        bdAmbito: '',
        dtUltimoCambio: '',
        rowVersion: '',
        softDeleted: false,
        visited: false,
        interacciones: 0,
        nombreTipoEvento: '',
        audiencias: [17],
        tematicas: [],
        categorias: [],
        facultadesGrado: [],
        programasGrado: [],
        facultadesPostGrado: [],
        programasPostGrado: [],
        esEnEspol: false,
        idCampus: 0,
        idZona: 0,
        idBloque: 0,
        idTipoUbicacion: 0,
        idUbicacion: 0
    }
}

export function buildAnuncioFormData(anuncio: AnunciosData): FormData {
    const forma = new FormData();

    // Campos numéricos
    forma.append("idAnuncio", anuncio.idAnuncio?.toString() ?? '');
    forma.append("idTipoEvento", anuncio.idTipoEvento?.toString() ?? '');
    forma.append("idArea", anuncio.idArea?.toString() ?? '');
    forma.append("ordenPresentacion", anuncio.ordenPresentacion?.toString() ?? '');

    // Campos de texto
    forma.append("dtEnvio", anuncio.dtEnvio ?? '');
    forma.append("txTitulo", anuncio.txTitulo ?? '');
    forma.append("txTexto", anuncio.txTexto ?? '');
    forma.append("txImagen", anuncio.txImagen ?? '');
    forma.append("txImagenCaratula", anuncio.txtImagenCaratula ?? '');
    forma.append("estadoMiEspol", anuncio.estadoMiEspol ?? '');
    forma.append("dtPublicacion", anuncio.dtPublicacion ?? '');
    forma.append("dtVigencia", anuncio.dtVigencia ?? '');
    forma.append("txUrl", anuncio.txUrl ?? '');
    forma.append("txLugar", anuncio.txLugar ?? '');
    forma.append("txtUrlMaps", anuncio.txtUrlMaps ?? '');
    forma.append("dtInicio", anuncio.dtInicio ?? '');
    forma.append("dtFin", anuncio.dtFin ?? '');
    forma.append("bdTipo", anuncio.bdTipo ?? '');
    forma.append("bdEstado", anuncio.bdEstado ?? '');
    forma.append("bdAmbito", anuncio.bdAmbito ?? '');
    forma.append("dtUltimoCambio", anuncio.dtUltimoCambio ?? '');

    // Booleanos
    forma.append("bdPublicarAutomatico", anuncio.bdPublicarAutomatico?.toString() ?? 'false');
    forma.append("bdIsReiterativo", anuncio.bdIsReiterativo?.toString() ?? 'false');
    forma.append("visited", anuncio.visited?.toString() ?? 'false');
    forma.append("esEnEspol", anuncio.esEnEspol?.toString() ?? 'false');

    // Otros campos numéricos
    forma.append("idCampus", anuncio.idCampus?.toString() ?? '');
    forma.append("idZona", anuncio.idZona?.toString() ?? '');
    forma.append("idBloque", anuncio.idBloque?.toString() ?? '');
    forma.append("idTipoUbicacion", anuncio.idTipoUbicacion?.toString() ?? '');
    forma.append("idUbicacion", anuncio.idUbicacion?.toString() ?? '');

    // Archivos
    if (anuncio.Imagen) forma.append("Imagen", anuncio.Imagen);
    if (anuncio.ImagenCaratula) forma.append("ImagenCaratula", anuncio.ImagenCaratula);

    // Arrays
    (anuncio.audiencias ?? []).forEach((audiencia: number, index: number) => {
        forma.append(`audiencias[${index}]`, audiencia.toString());
    });

    const programasG = syncCodFacCarr(anuncio.facultadesGrado ?? [], anuncio.programasGrado ?? []);
    programasG.forEach((prog, index) => {
        forma.append(`programasGrado[${index}]`, prog.toString());
    });

    const programasP = syncCodFacCarr(anuncio.facultadesPostGrado ?? [], anuncio.programasPostGrado ?? []);
    programasP.forEach((prog, index) => {
        forma.append(`programasPostGrado[${index}]`, prog.toString());
    });

    (anuncio.tematicas ?? []).forEach((tematica: any, index: number) => {
        forma.append(`tematicas[${index}].idTematica`, tematica.idTematica?.toString() ?? '');
        forma.append(`tematicas[${index}].txtNombre`, tematica.txtNombre ?? '');
    });

    (anuncio.categorias ?? []).forEach((categoria: any, index: number) => {
        forma.append(`categorias[${index}].idCategoria`, categoria.idCategoria?.toString() ?? '');
        forma.append(`categorias[${index}].txNombreCategoria`, categoria.txNombreCategoria ?? '');
    });

    return forma;
}

export function syncCodFacCarr(codfac: number[], codcarr: string[]): string[] {
    let result = [...codcarr]; // copiamos para no mutar el original

    for (const fac of codfac) {
        const existe = result.some(c => c.split("-")[0] === fac.toString());
        if (!existe) {
            result.push(`${fac}-0`);
        }
    }
    return result;
}

export function getCodFacFromCodCarr(codcarr: string[]): number[] {
    // Extraemos la parte antes del "-" y convertimos a número
    const codfac = codcarr.map(c => Number(c.split("-")[0]));

    // Eliminamos duplicados usando Set
    return [...new Set(codfac)];
}